/**
 * Pure query-string builder for `GET /api/admin/payouts/accruals` (API-FIN-4).
 *
 * Empty values are omitted; `limit` is always the BO page size (< the API
 * default of 50). Returns a string starting with `?`.
 *
 * Side-effect free — unit-tested in `accruals-filters.test.ts`.
 */
import { ACCRUALS_PAGE_SIZE } from "./constants";

export interface AccrualsFilters {
  readonly venueId: string;
  readonly subscriptionId: string;
  /** 1-indexed. */
  readonly page: number;
}

export function buildAccrualsQuery(filters: AccrualsFilters): string {
  const params = new URLSearchParams();

  const venue = filters.venueId.trim();
  if (venue) params.set("venueId", venue);

  const subscription = filters.subscriptionId.trim();
  if (subscription) params.set("subscriptionId", subscription);

  if (filters.page > 1) params.set("page", String(filters.page));
  params.set("limit", String(ACCRUALS_PAGE_SIZE));

  return `?${params.toString()}`;
}
